import { render, staticRenderFns } from "./LabelDashIcon.vue?vue&type=template&id=2cddcd11&"
import script from "./LabelDashIcon.vue?vue&type=script&lang=js&"
export * from "./LabelDashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports